export const experiences = [
  {
    companyKey: "experience.companies.botmaker",
    titleKey: "experience.titles.softwareEngineer",
    summaryKeys: [
      "experience.botmaker.summary.0"
    ],
    responsibilityKeys: [
      "experience.botmaker.resp.0",
      "experience.botmaker.resp.1",
      "experience.botmaker.resp.2",
      "experience.botmaker.resp.3"
    ],
    techStackKey: "experience.botmaker.techStack",
    from: { month: 7, monthNameKey: 'experience.months.july', year: 2024 },
    to: { month: 7, monthNameKey: 'experience.months.july', year: 2026 },
    languageKey: 'experience.languages.spanish',
    contractKey: 'experience.contracts.fullTime',
    locationKey: 'experience.locations.remote'
  },
  {
    companyKey: "experience.companies.accenture",
    titleKey: "experience.titles.softwareEngineer",
    summaryKeys: [
      "experience.accenture.summary.0"
    ],
    responsibilityKeys: [
      "experience.accenture.resp.0",
      "experience.accenture.resp.1",
      "experience.accenture.resp.2",
      "experience.accenture.resp.3",
      "experience.accenture.resp.4"
    ],
    techStackKey: "experience.accenture.techStack",
    from: { month: 4, monthNameKey: 'experience.months.april', year: 2023 },
    to: { month: 7, monthNameKey: 'experience.months.july', year: 2024 },
    languageKey: 'experience.languages.both',
    contractKey: 'experience.contracts.fullTime',
    locationKey: 'experience.locations.remote'
  },
  {
    companyKey: "experience.companies.number8",
    titleKey: "experience.titles.softwareEngineer",
    summaryKeys: [
      "experience.number8.summary.0"
    ],
    responsibilityKeys: [
      "experience.number8.resp.0",
      "experience.number8.resp.1",
      "experience.number8.resp.2",
      "experience.number8.resp.3"
    ],
    techStackKey: "experience.number8.techStack",
    from: { month: 3, monthNameKey: 'experience.months.march', year: 2022 },
    to: { month: 4, monthNameKey: 'experience.months.april', year: 2023 },
    languageKey: 'experience.languages.english',
    contractKey: 'experience.contracts.contractor',
    locationKey: 'experience.locations.remote'
  },
  {
    companyKey: "experience.companies.globant",
    titleKey: "experience.titles.softwareEngineer",
    summaryKeys: [
      "experience.globant.summary.0"
    ],
    responsibilityKeys: [
      "experience.globant.resp.0",
      "experience.globant.resp.1",
      "experience.globant.resp.2",
      "experience.globant.resp.3",
      "experience.globant.resp.4"
    ],
    techStackKey: "experience.globant.techStack",
    from: { month: 9, monthNameKey: 'experience.months.september', year: 2021 },
    to: { month: 3, monthNameKey: 'experience.months.march', year: 2022 },
    languageKey: 'experience.languages.both',
    contractKey: 'experience.contracts.fullTime',
    locationKey: 'experience.locations.remote'
  },
  {
    companyKey: "experience.companies.imagosur",
    titleKey: "experience.titles.softwareEngineer",
    summaryKeys: [
      "experience.imagosur.summary.0",
      "experience.imagosur.summary.1"
    ],
    responsibilityKeys: [
      "experience.imagosur.resp.0",
      "experience.imagosur.resp.1",
      "experience.imagosur.resp.2",
      "experience.imagosur.resp.3",
      "experience.imagosur.resp.4"
    ],
    techStackKey: "experience.imagosur.techStack",
    from: { month: 3, monthNameKey: 'experience.months.march', year: 2016 },
    to: { month: 9, monthNameKey: 'experience.months.september', year: 2020 },
    languageKey: 'experience.languages.spanish',
    contractKey: 'experience.contracts.fullTime',
    locationKey: 'experience.locations.onSite'
  }
]
